import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})
export class ClassSetService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewClassSet() {
    return this.http.get(this.baseurl +'/api/ClassSets/GetClassSets')
  }

  addClassSet(classSetForm) {
    console.log(classSetForm);
    return this.http.post(this.baseurl+'/api/ClassSets', classSetForm)
  }

  editClassSet(id, classSetForm) {
    console.log(classSetForm);
    return this.http.put(this.baseurl+`/api/ClassSets/${id}`, classSetForm)
  }

  deleteClassSet(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/ClassSets/${id}`)
  }
}
